<template>
    <div class="luck-draw-index">
        <lucky-draw/>
    </div>
</template>

<script>
    import LuckyDraw from '../../components/luck-draw/luckywheel'

    export default {
        name: "MyLuckyDraw",
        components: {
            LuckyDraw
        }

    }
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// MyLuckDraw.vue?c92e26e6